export default "__VITE_ASSET__xhStKV9i__"